import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7458b9de")
const _hoisted_1 = { class: "toolbar__left" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = { class: "p-inputgroup" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    class: "p-mb-3",
    header: "Filters",
    toggleable: true,
    collapsed: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FloatLabel, { label: "Project name" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.advFilters.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters.name = $event)),
                  placeholder: "Search by Project name",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitFilters()))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Button, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitFilters())),
                  icon: "pi pi-check",
                  class: "p-button-primary"
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}